<template>
  <div>
    <div class="listingpush" />

    <!-- Sol Sidebar -->
    
    <!-- Mobile Sidebar (animated in) -->
    <div
      id="modal-filtre"
      class="d-lg-none"
      :class="[
        showFilter
          ? 'show-filter animate__animated animate__backInLeft'
          : 'animate__animated animate__backOutLeft',
        isFirstRender ? 'hide-animation' : '',
      ]"
      style="display: block; background-color: rgba(255, 255, 255, 0.95); position: fixed; z-index: 1050; top: 0; left: 0; height: 100vh; overflow-y: auto;"
      @animationend="handleAnimationEnd"
    >
      <div class="left_sidebar_area p-2">
        <PetFilterPanel 
          :filters="filters"
          :categories="categories"
          :pet-counts="petCounts"
          :current-category-data="currentCategoryData"
          :coat-pattern-counts="coatPatternCounts"
          :color-counts="colorCounts"
          :age-group-counts="ageGroupCounts"
          :health-vetting-counts="healthVettingCounts"
          :ad-type-counts="adTypeCounts"
          :age-groups="ageGroups"
          :selected-ad-type="selectedAdType"
          :active-filter-panel="activeFilterPanel"
          :postal-code="postalCode"
          :userpostcode="userpostcode"
          :loading="loading"
          :address="address"
          :error="error"
          :price-inputs="priceInputs"
          @toggleFilter="toggleFilter"
          @getAddress="getAddress"
          @updateFilters="updateFilters"
          @updateAdType="updateAdType"
          @applyPriceFilter="applyPriceFilter"
          @resetPriceFilter="resetPriceFilter"
          @update:postalCode="val => postalCode = val"
          @update:activeFilterPanel="val => activeFilterPanel = val"
        />
      </div>
    </div>

    <!-- Pet Details Modal -->

    <section class="cat_product_area">
      <div class="container conlist">
        <div class="flex-row-reverse">
          <!-- Ana İçerik Alanı -->
          <div class="col-lg-12">
            <!-- Loading Spinner -->
            <div
              v-show="loading"
              class="loading"
            >
              <LoadingSpinner />
              <p>Loading...</p>
            </div>
            <div
              v-if="error"
              class="error"
            >
              {{ error }}
            </div>

            <!-- Breadcrumb -->
            <div
              class="row text-center"
              style="font-size: 12px"
            >
              <!-- Mevcut breadcrumb kodu -->
              <div class="banner_content">
                <div class="page_link breadc">
                  <a
                    href="javascript:void(0)"
                    @click="$router.push('/')"
                  >Home </a>
                  <a href="" />
                  <a
                    href="javascript:void(0)"
                    @click="$router.go(-1)"
                  >Go Back</a>
                </div>
              </div>
            </div>

            <div
              class=""
              style="background: linear-gradient(to bottom, #fbf8f8, #ffffff)"
            >
              <div
                class=""
                style="
                  transition:
                    background 0.3s,
                    border 0.3s,
                    border-radius 0.3s,
                    box-shadow 0.3s,
                    transform var(--e-transform-transition-duration, 0.4s);
                "
              >
                <div
                  class="section-title section-title-dk-blue fl-wrap"
                  style="width: 100%; position: relative;  text-align: center"
                >
                  <h2 v-if="filters.category">
                    <span>{{ filters.category }} Category</span>
                  </h2>
                  <div class="section-subtitle">
                    Your Listings
                  </div>
                  <span class="section-separator section-separator-dk-blue" />
                  <p>
                    (showing
                    {{ category ? ` from ${category}` : '' }}: {{ totalCount }} ads)
                  </p>
                </div>
              </div>
            </div>
            <!-- Pet Listings -->
          </div>

          <div
            id="petListingDiv"
            class="row"
          >
            <!-- Desktop Sidebar (always visible on lg and up) -->
            <div
              class="col-lg-3 d-none d-lg-block sticky-top"
              style="top: 0px; z-index: 100;"
            >
              <div class="left_sidebar_area">
                <PetFilterPanel 
                  :filters="filters"
                  :categories="categories"
                  :pet-counts="petCounts"
                  :current-category-data="currentCategoryData"
                  :coat-pattern-counts="coatPatternCounts"
                  :color-counts="colorCounts"
                  :age-group-counts="ageGroupCounts"
                  :health-vetting-counts="healthVettingCounts"
                  :ad-type-counts="adTypeCounts"
                  :age-groups="ageGroups"
                  :selected-ad-type="selectedAdType"
                  :active-filter-panel="activeFilterPanel"
                  :postal-code="postalCode"
                  :userpostcode="userpostcode"
                  :loading="loading"
                  :address="address"
                  :error="error"
                  :price-inputs="priceInputs"
                  @toggleFilter="toggleFilter"
                  @getAddress="getAddress"
                  @updateFilters="updateFilters"
                  @updateAdType="updateAdType"
                  @applyPriceFilter="applyPriceFilter"
                  @resetPriceFilter="resetPriceFilter"
                  @update:postalCode="val => postalCode = val"
                  @update:activeFilterPanel="val => activeFilterPanel = val"
                />
              </div>
            </div>

    
            <div class="col-lg-9 col-12">
              <!-- Product Top Bar -->
              <div class="product_top_bar lst-drps mb-3">
                <div class="flex-wrap">
                  <div class="left_drop sort-controls">
                    <select
                      v-model="filters.sort"
                      class="selectpicker"
                      @change="updateFilters({ sort: $event.target.value })"
                    >
                      <option value="bestMatch">
                        Best Match
                      </option>
                      <option value="newest">
                        Newest First
                      </option>
                      <option value="oldest">
                        Oldest First
                      </option>
                      <option value="pricelowToHigh">
                        Price: Low to High
                      </option>
                      <option value="priceHighToLow">
                        Price: High to Low
                      </option>
                      <option value="mostViewed">
                        Most Viewed
                      </option>
                      <option value="premium">
                        Premium Boosted
                      </option>
                    </select>
                  </div>
                  <div class="center_drop sort-controls">
                    <select
                      id="id_category"
                      :value="filters.category || 'All'"
                      name="category"
                      @change="updateFilters({ category: $event.target.value })"
                    >
                      <option value="All">
                        All Categories
                      </option>
                      <option
                        v-for="catOption in categories"
                        :key="catOption.id"
                        :value="catOption.name"
                      >
                        {{ catOption.name }} ({{ petCounts[`count_${catOption.name}`] || 0 }})
                      </option>
                    </select>
                  </div>
                </div>
                <div class="right_page ml-auto msifir">
                  <ul
                    class="search-title-tab-list"
                    style="margin: unset"
                  >
                    <li>
                      <a
                        href="#"
                        type="button"
                        class="gorunur d-lg-none"
                        style="row-gap: 0px; font-size: 30px; border: none; width: unset"
                        @click.prevent="toggleFilter"
                      >
                        <i
                          class="icon-list3"
                          style="font-size: 40px"
                        />
                        <span style="font-size: 10px">Filters</span>
                      </a>
                    </li>

                    <li>
                      <router-link
                        to="/petmapview"
                        class="pet-listing-view-control-btn"
                        style="row-gap: 0px; font-size: 30px; border: none; width: unset"
                      >
                        <i
                          class="icon-map"
                          style="font-size: 40px"
                        />
                        <span style="font-size: 10px">On Map</span>
                      </router-link>
                    </li>

                    <li>
                      <a
                        href="#"
                        class="pet-listing-view-control-btn"
                        style="row-gap: 0px; font-size: 30px; border: none; width: unset"
                        @click.prevent="changeCardView"
                      >
                        <i
                          :class="cardView === 'grid' ? 'icon-icons2' : 'icon-menu2'"
                          style="font-size: 40px"
                        />
                        <span style="font-size: 10px">View</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

            
              <!-- Filter Pills bölümünü ekleyelim -->
              <div
                v-if="hasActiveFilters"
                class="selected-filters"
              >
                <div class="filter-pills">
                  <!-- Sort filtresi -->
                  <div
                    v-if="filters.sort && filters.sort !== 'newest'"
                    class="filter-pill"
                  >
                    <span>Sort:
                      {{
                        filters.sort === 'pricelowToHigh'
                          ? 'Price: Low to High'
                          : filters.sort === 'priceHighToLow'
                            ? 'Price: High to Low'
                            : filters.sort === 'mostViewed'
                              ? 'Most Viewed'
                              : filters.sort === 'premium'
                                ? 'Premium Boosted'
                                : filters.sort === 'oldest'
                                  ? 'Oldest First'
                                  : 'Newest First'
                      }}
                    </span>
                    <button
                      class="remove-filter"
                      @click="updateFilters({ sort: 'newest' })"
                    >
                      <i class="icon-cross" />
                    </button>
                  </div>
                  <div
                    v-if="hasActiveFilters"
                    class="selected-filters"
                  >
                    <div class="filter-pills">
                      <!-- Kategori filtresi -->
                      <div
                        v-if="filters.category"
                        class="filter-pill"
                      >
                        <span>Category: {{ filters.category }}</span>
                        <button
                          class="remove-filter"
                          @click="updateFilters({ category: null })"
                        >
                          <i class="icon-cross" />
                        </button>
                      </div>

                      <!-- Alt kategori filtresi -->
                      <div
                        v-if="filters.subCategory"
                        class="filter-pill"
                      >
                        <span>Sub Category: {{ filters.subCategory }}</span>
                        <button
                          class="remove-filter"
                          @click="updateFilters({ subCategory: null })"
                        >
                          <i class="icon-cross" />
                        </button>
                      </div>

                      <!-- İlan tipi filtresi -->
                      <div
                        v-if="filters.adType"
                        class="filter-pill"
                      >
                        <span>Ad Type: {{ filters.adType }}</span>
                        <button
                          class="remove-filter"
                          @click="updateAdType(filters.adType)"
                        >
                          <i class="icon-cross" />
                        </button>
                      </div>

                      <!-- Fiyat aralığı filtresi -->
                      <div
                        v-if="filters.priceRangeMinPrice || filters.priceRangeMaxPrice"
                        class="filter-pill"
                      >
                        <span>
                          Price:
                          {{ filters.priceRangeMinPrice ? `£${filters.priceRangeMinPrice}` : '£0' }}
                          -
                          {{ filters.priceRangeMaxPrice ? `£${filters.priceRangeMaxPrice}` : 'Any' }}
                        </span>
                        <button
                          class="remove-filter"
                          @click="resetPriceFilter"
                        >
                          <i class="icon-cross" />
                        </button>
                      </div>

                      <!-- Tüm filtreleri temizle -->
                      <button
                        v-if="hasActiveFilters"
                        class="reset-all-filters"
                        @click="resetAllFilters"
                      >
                        Clear All Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="filteredPetAds.length"
                class="latest_product_inner"
              >
                <div
                  id="bilgin"
                  class="most_product_inner"
                >
                  <div
                    v-for="pet in filteredPetAds"
                    :key="pet.id"
                    :class="
                      cardView === 'grid'
                        ? 'dik col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-6 '
                        : 'yatayads yatay col-12 col-xxl-6 Pet'
                    "
                  >
                    <div
                      v-once
                      class="static-content"
                    >
                    <!-- Statik içerik -->
                    </div>
                    <!-- Dinamik içerik -->

                    <div
                      class="pet-link"
                      @click="showPetDetails(pet.id, pet.category, pet.subCategory)"
                    >
                      <div :class="['card', { 'boosted': pet.boosted, 'gradient-border': pet.boosted }]">
                        <div class="card-header justify-content-between">
                          <span
                            class="col"
                            style="font-size: 11.6px"
                          ><i>{{ pet.subCategory }} </i></span>
                          <span
                            v-if="pet.boosted"
                            class="col boostabso"
                            style="font-size: 11.6px"
                          ><a class="animtext">
                            <i class="icon-diamond2" />Boosted<i class="icon-diamond2" /></a></span>
                          <span
                            class="col text-muted"
                            style="font-size: 11.6px; padding-left: 0"
                          >
                            <i class="icon-footprint" />
                            {{ calculateDistance(userLat, userLong, pet.adLocation) }}
                            <i class="icon-aim">
                              <span class="citykisa">{{ pet.postalTown }} </span>
                            </i>
                          </span>
                        </div>
                        <div class="hor-var">
                          <!-- Image -->
                          <div class="f_p_item resim_ana_d pricing-section">
                            <div class="ribbon">
                              <span> {{ pet.adType }} </span>
                            </div>
                            <span class="resim_spa">
                              <div class="f_p_img resim_d">
                                <div
                                  v-if="pet.coverImage"
                                  class="cover-image"
                                >
                                  <img
                                    class="img-fluid resim rounded"
                                    :src="pet.coverImage"
                                    alt="Cover Image"
                                  >
                                </div>
                                <div
                                  v-else
                                  class="cover-image"
                                >
                                  <img
                                    class="img-fluid resim"
                                    src="https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2FnoImage.jpg?alt=media"
                                    alt="Cover Image"
                                  >
                                </div>
                              </div>
                            </span>
                          </div>
                          <!-- Ad body -->
                          <div class="card-body">
                            <h5 class="price_h5">
                              £{{ pet.price }}
                            </h5>
                            <h6 class="card-title">
                              {{ pet.title }}
                            </h6>
                            <!-- yatayda aktif -->
                            <p class="card-text">
                              {{ pet.description }} ✨ Blues …
                            </p>
                            <h6 class="user-reg">
                              <i
                                class="icon-clipboard-empty"
                                style="font-size: 20px; color: #c5322d; padding-left: 10px"
                              />Individual
                            </h6>
                            <h6 class="user-reg">
                              <i
                                class="icon-crown"
                                style="font-size: 20px; color: #c5322d; padding-left: 10px"
                              />Premium
                            </h6>
                          <!-- <p class="card-text">All kittens’ vaccination done, Health check done, Litter trained, Worming done, They are ready to go. ✨ Blues …</p> -->
                          </div>
                          <!-- Ad footer -->
                          <div class="card-footer">
                            <div class="">
                              <a
                                style="font-size: 12px"
                                href="javascript:void(0)"
                              >Added: {{ formatDate(pet.createdAt) }}
                              </a>
                              <span
                                class="text-muted age text-end mb-0"
                                style="font-size: smaller; float: right"
                              >{{ calculateAge(pet.birthDate) }}</span><span
                                class="birth"
                                hidden=""
                              >2024-11-05</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Infinite Scroll Trigger -->
            <div
              v-if="hasMore"
              ref="loadMoreTrigger"
              style="height: 20px; margin: 20px 0"
            />

            <!-- Loading ve No Data durumları -->
            <div
              v-if="loading"
              class="bottom-loading"
            >
              <LoadingSpinner />
            </div>

            <div
              v-if="!loading && !filteredPetAds.length"
              class="row mt-2"
            >
              <div class="col-12 text-center">
                <p>No active listings found for the selected category.</p>
              </div>
            </div>

            <div
              v-if="loading && !filteredPetAds.length"
              class="loading"
            >
              <LoadingSpinner />
              <p>Loading...</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      v-if="showModal"
      class="pet-modal animate__animated"
      :class="{ animate__slideInRight: showPopup, animate__slideOutRight: !showPopup }"
      @animationend="handleModalAnimation"
    >
      <button
        class="close-button animate__animated animate__shakeY"
        @click="closeModal"
      >
        Close
      </button>
      <div class="pet-modal-content">
        <PetDetails />
      </div>
    </div>
  </div>
</template>

<script setup>
  import PetDetails from '@/components/PetDetails.vue';
  import { ref, computed, watch, onMounted, nextTick, onUnmounted } from 'vue';
  import { useUserStore } from '@/stores/userStore';
  import { storeToRefs } from 'pinia';
  import { collection, query, getDocs, orderBy, doc, getDoc } from 'firebase/firestore';
  import { db } from '@/firebase/index.js';
  import { useRoute, useRouter } from 'vue-router';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  import { useGetPetAds } from '@/composables/getPetAds';
  // Yardımcı fonksiyonlar
  import PetFilterPanel from '@/components/PetFilterPanel.vue';
import { calculateAge, calculateAgeGroup, formatDate } from '@/utils/dateUtils';
  import { calculateDistance } from '@/utils/locationUtils';
  import { debounce } from '@/utils/helpers';
  import { usePetStore } from '@/stores/petStore'; // Pinia store'u import et
  import { validatePostalCode } from '@/utils/locationUtils';

  // Adres tanımlamaları
  const postCodeUpdateTrigger = ref(0);
  const coordinatesUpdateTrigger = ref(0);
  const address = ref('');
  const error = ref(null);
  const loading = ref(false);

  // State tanımlamaları
  const postalCode = ref('');
  const userStore = useUserStore();
  const { userData } = storeToRefs(userStore);
  const route = useRoute();

  const category = ref(route.params.category || null);
  const categories = ref([]);
  const petCounts = ref({});
  const cardView = ref(localStorage.getItem('preferred_view') || 'grid');
  const loadMoreTrigger = ref(null);
  let observer = null;
  const showFilter = ref(false);
  const isFirstRender = ref(true);

  const selectedAdType = ref(null);
  // Script kısmında yeni state'ler ekleyelim
  const priceInputs = ref({
    min: null,
    max: null,
  });

  // Fiyat filtresi uygulama fonksiyonu
  const applyPriceFilter = () => {
    let minPrice = Number(priceInputs.value.min);
    let maxPrice = Number(priceInputs.value.max);

    // Değerleri karşılaştır ve gerekirse swap yap
    if (minPrice && maxPrice && minPrice > maxPrice) {
      [minPrice, maxPrice] = [maxPrice, minPrice];
      // Input değerlerini de güncelle
      priceInputs.value = {
        min: minPrice,
        max: maxPrice,
      };
    }

    updateFilters({
      priceRangeMinPrice: minPrice || null,
      priceRangeMaxPrice: maxPrice || null,
    });
  };

  // Filter Pill'leri göstermek için computed property
  const hasActiveFilters = computed(() => {
    return (
      filters.value.category ||
      filters.value.subCategory ||
      filters.value.adType ||
      filters.value.priceRangeMinPrice ||
      filters.value.priceRangeMaxPrice ||
      (filters.value.sort && filters.value.sort !== 'newest')
    ); // sort için kontrol ekledik
  });

  const resetAllFilters = () => {
    filters.value = {
      category: null,
      subCategory: null,
      coatPattern: null,
      color: null,
      ageGroup: null,
      priceRangeMaxPrice: null,
      priceRangeMinPrice: null,
      adType: null,
      sort: 'newest',
      isVaccinated: false,
      isMicrochipped: false,
      isNeutered: false,
      isHealthChecked: false,
      isWormTreated: false
    };
    selectedAdType.value = null;
    priceInputs.value = { min: null, max: null };
    fetchPetAds(false, filters.value);
  };

  // Reset fonksiyonu
  const resetPriceFilter = () => {
    priceInputs.value = {
      min: null,
      max: null,
    };
    updateFilters({
      priceRangeMinPrice: null,
      priceRangeMaxPrice: null,
    });
  };

  // updateAdType fonksiyonu
  const updateAdType = (type) => {
    selectedAdType.value = selectedAdType.value === type ? null : type;
    updateFilters({ adType: selectedAdType.value });
  };

  // Filtre state'ini tanımla
  const filters = ref({
    category: null,
    subCategory: null,
    coatPattern: null,
    color: null,
    ageGroup: null,
    priceRangeMaxPrice: null,
    priceRangeMinPrice: null,
    adType: null,
    sort: 'newest', // Varsayılan sıralama değeri
    isVaccinated: false,
    isMicrochipped: false,
    isNeutered: false,
    isHealthChecked: false,
    isWormTreated: false
  });

  // Filtre değişikliklerini izle ve toplu update yap
  const updateFilters = debounce(async (newFilters) => {
    if (newFilters.category === 'All') {
      newFilters.category = null;
    }

    const sortOrCategoryChanged = 
      ('category' in newFilters && newFilters.category !== filters.value.category) ||
      ('sort' in newFilters && newFilters.sort !== filters.value.sort);

    filters.value = {
      ...filters.value,
      ...newFilters,
    };

    let forceFetch = false;
    if ((filters.value.priceRangeMinPrice || filters.value.priceRangeMaxPrice) && 
        ['newest', 'oldest', 'bestMatch', 'mostViewed', 'premium'].includes(filters.value.sort)) {
      filters.value.sort = 'pricelowToHigh';
      forceFetch = true;
    }

    if (sortOrCategoryChanged || forceFetch) {
      await fetchPetAds(false, filters.value);
      setupObserver();
    }
  }, 300);

  const currentCategoryData = computed(() => {
    if (!filters.value.category) return null;
    return categories.value.find(c => c.name === filters.value.category) || null;
  });

  const ageGroups = ['0-3 Months', '3-6 Months', '6-12 Months', '1-2 Years', '2-4 Years', '4-8 Years', '8+ Years'];

  // Filtre değişikliklerini kaydet
  watch(
    filters,
    (newFilters) => {
      localStorage.setItem('petFilters', JSON.stringify(newFilters));
    },
    { deep: true },
  );

  // Touch olayları için state
  const touchStartX = ref(0);
  const touchEndX = ref(0);

  // Touch handler fonksiyonları
  const handleTouchStart = (e) => {
    touchStartX.value = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    if (showModal.value) {
      e.preventDefault();
    }
    touchEndX.value = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchEndX.value !== 0) {
      const swipeDistance = touchStartX.value - touchEndX.value;

      // Eğer sola doğru 100px'den fazla kaydırıldıysa filtreyi kapat
      if (swipeDistance > 100 && showFilter.value) {
        toggleFilter();
      }
    }

    // Touch değerlerini sıfırla
    touchStartX.value = 0;
    touchEndX.value = 0;
  };

  
  const activeFilterPanel = ref(null);
  const draftFilters = ref(null);
  
  // eslint-disable-next-line no-unused-vars
  const openSubPanel = (panel) => {
    if (!draftFilters.value) {
      draftFilters.value = JSON.parse(JSON.stringify(filters.value));
    }
    activeFilterPanel.value = panel;
  };
  
  // eslint-disable-next-line no-unused-vars
  const applyMobileFilters = () => {
    if (draftFilters.value) {
      filters.value = { ...draftFilters.value };
    }
    activeFilterPanel.value = null;
    toggleFilter();
  };

  const toggleFilter = () => {
    if (isFirstRender.value) {
      isFirstRender.value = false;
    }
    showFilter.value = !showFilter.value;
  };

  const handleAnimationEnd = (event) => {
    if (event.animationName === 'backOutLeft') {
      // Animasyon bittikten sonra yapılacak işlemler
    }
  };

  const distanceCache = new Map();

  // GetPetAds composable'ından state'leri al
  const { petAds, fetchPetAds, hasMore, totalCount } = useGetPetAds();


  const isAdMatched = (ad, excludeFilterKeys = []) => {
    // Subcategory
    if (!excludeFilterKeys.includes('subCategory') && filters.value.subCategory && ad.subCategory !== filters.value.subCategory) return false;
    
    // Coat Pattern
    if (!excludeFilterKeys.includes('coatPattern') && filters.value.coatPattern && ad.coat_pattern !== filters.value.coatPattern) return false;
    
    // Color
    if (!excludeFilterKeys.includes('color') && filters.value.color && ad.color !== filters.value.color) return false;
    
    // Age Group
    const computedAgeGroup = (ad.ageGroup && ad.ageGroup !== "Not Specified") ? ad.ageGroup : (ad.birthDate ? calculateAgeGroup(ad.birthDate) : null);
    if (!excludeFilterKeys.includes('ageGroup') && filters.value.ageGroup && computedAgeGroup !== filters.value.ageGroup) return false;
    
    // Ad Type
    if (!excludeFilterKeys.includes('adType') && filters.value.adType && ad.adType !== filters.value.adType) return false;
    
    // Price Range
    if (!excludeFilterKeys.includes('priceRange')) {
      if (filters.value.priceRangeMinPrice && Number(ad.price) < Number(filters.value.priceRangeMinPrice)) return false;
      if (filters.value.priceRangeMaxPrice && Number(ad.price) > Number(filters.value.priceRangeMaxPrice)) return false;
    }
    
    // Health Booleans
    if (!excludeFilterKeys.includes('health')) {
      if (filters.value.isVaccinated && !ad.isVaccinated) return false;
      if (filters.value.isMicrochipped && !ad.isMicrochipped) return false;
      if (filters.value.isNeutered && !ad.isNeutered) return false;
      if (filters.value.isHealthChecked && !ad.isHealthChecked) return false;
      if (filters.value.isWormTreated && !ad.isWormTreated) return false;
    }

    return true;
  };

  const coatPatternCounts = computed(() => {
    const counts = {};
    petAds.value.forEach(ad => {
      if (isAdMatched(ad, ['coatPattern']) && ad.coat_pattern) {
        counts[ad.coat_pattern] = (counts[ad.coat_pattern] || 0) + 1;
      }
    });
    return counts;
  });

  const colorCounts = computed(() => {
    const counts = {};
    petAds.value.forEach(ad => {
      if (isAdMatched(ad, ['color']) && ad.color) {
        counts[ad.color] = (counts[ad.color] || 0) + 1;
      }
    });
    return counts;
  });

  const ageGroupCounts = computed(() => {
    const counts = {};
    petAds.value.forEach(ad => {
      if (isAdMatched(ad, ['ageGroup'])) {
        const computedAgeGroup = (ad.ageGroup && ad.ageGroup !== "Not Specified") ? ad.ageGroup : (ad.birthDate ? calculateAgeGroup(ad.birthDate) : null);
        if (computedAgeGroup && computedAgeGroup !== "Not Specified") {
          counts[computedAgeGroup] = (counts[computedAgeGroup] || 0) + 1;
        }
      }
    });
    return counts;
  });

  const healthVettingCounts = computed(() => {
    const counts = {
      isVaccinated: 0,
      isMicrochipped: 0,
      isNeutered: 0,
      isHealthChecked: 0,
      isWormTreated: 0
    };
    petAds.value.forEach(ad => {
      if (isAdMatched(ad, ['health'])) {
        if (ad.isVaccinated) counts.isVaccinated++;
        if (ad.isMicrochipped) counts.isMicrochipped++;
        if (ad.isNeutered) counts.isNeutered++;
        if (ad.isHealthChecked) counts.isHealthChecked++;
        if (ad.isWormTreated) counts.isWormTreated++;
      }
    });
    return counts;
  });

  const adTypeCounts = computed(() => {
    const counts = {};
    petAds.value.forEach(ad => {
      if (isAdMatched(ad, ['adType']) && ad.adType) {
        counts[ad.adType] = (counts[ad.adType] || 0) + 1;
      }
    });
    return counts;
  });

  const filteredPetAds = computed(() => {
    return petAds.value.filter(ad => isAdMatched(ad));
  });

  // Default Londra koordinatları
  const DEFAULT_COORDINATES = {
    lat: 51.509865,
    lng: -0.118092,
  };

  // Koordinatlar için computed property
  const coordinates = computed(() => {
    coordinatesUpdateTrigger.value; // Dependency tracking

    const localLat = parseFloat(localStorage.getItem('userLat'));
    const localLng = parseFloat(localStorage.getItem('userLng'));

    if (localLat && localLng) {
      return { lat: localLat, lng: localLng };
    }

    if (userData.value?.latitude && userData.value?.longitude) {
      return {
        lat: userData.value.latitude,
        lng: userData.value.longitude,
      };
    }

    return DEFAULT_COORDINATES;
  });

  // Computed Properties

  const userLat = computed(() => {
    coordinatesUpdateTrigger.value; // Dependency tracking
    return coordinates.value.lat || userData.value?.latitude || 0;
  });

  const userLong = computed(() => {
    coordinatesUpdateTrigger.value; // Dependency tracking
    return coordinates.value.lng || userData.value?.longitude || 0;
  });

  const userpostcode = computed(() => {
    postCodeUpdateTrigger.value; // Dependency tracking için
    const localPostcode = localStorage.getItem('userPostcode');
    if (localPostcode) {
      return localPostcode;
    }

    // 2. Yoksa giriş yapmış kullanıcı bilgilerinden al
    if (userData.value?.postalCode) {
      return userData.value.postalCode;
    }

    // 3. Hiçbiri yoksa default mesaj
    return 'Postcode not available';
  });

  // Sıralama ve filtreleme computed'ları

  // Helper functions
  const debouncedLoadMore = debounce(() => {
    if (hasMore.value && !loading.value) {
      loadMore();
    }
  }, 100);

  // Intersection Observer setup
  const setupObserver = () => {
    observer?.disconnect();

    observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry?.isIntersecting) {
          debouncedLoadMore();
        }
      },
      {
        threshold: 0.1,
        rootMargin: '100px 0px',
        root: null,
      },
    );

    if (loadMoreTrigger.value) {
      observer.observe(loadMoreTrigger.value);
    }
  };

  // Ana fonksiyonlar <-bu düzeltilecek
  const loadMore = async () => {
    try {
      if (!hasMore.value || loading.value) return;
      await fetchPetAds(true, filters.value);
    } catch (err) {
      handleError(err, 'loadMore');
    }
  };

  const fetchCategories = async () => {
    try {
      const categoriesRef = collection(db, 'petcategories');
      const q = query(categoriesRef, orderBy('order', 'asc'));
      const querySnapshot = await getDocs(q);
      categories.value = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Fetch pet counts from metadata
      const countsDoc = await getDoc(doc(db, 'metadata', 'petCounts'));
      if (countsDoc.exists()) {
        petCounts.value = countsDoc.data();
      }
    } catch (error) {
      console.error('Error fetching categories or counts:', error);
    }
  };

  const getAddress = async () => {
    if (!postalCode.value.trim()) return;

    loading.value = true;
    error.value = null;

    try {
      // locationUtils'den validatePostalCode fonksiyonunu kullan
      const result = await validatePostalCode(postalCode.value.toLowerCase().replace(/\s/g, ''));

      if (!result.isValid) {
        throw new Error(result.error || 'Post code is invalid');
      }

      // Cache'i temizle
      distanceCache.clear();

      // localStorage güncelle
      localStorage.setItem('userLat', result.latitude);
      localStorage.setItem('userLng', result.longitude);
      localStorage.setItem('userPostcode', result.postalTown);

      // Trigger'ları güncelle
      coordinatesUpdateTrigger.value++;
      postCodeUpdateTrigger.value++;

      // UI güncellemesi için bekle
      await nextTick();

      // Adres metnini güncelle
      address.value = `${postalCode.value} - ${result.postalTown}`;
    } catch (err) {
      console.error('Error getting address:', err);
      error.value = err.message || 'Error getting address';
    } finally {
      loading.value = false;
    }
  };

  const changeCardView = () => {
    cardView.value = cardView.value === 'grid' ? 'list' : 'grid';
    localStorage.setItem('preferred_view', cardView.value);
  };

  const handleError = (error, context) => {
    console.error(`Error in ${context}:`, error);
    error.value = `Error : ${error.message}`;
  };

  // Pinia store'u kullan
  const petStore = usePetStore();

  // İlan detaylarını gösterme fonksiyonu // Popup'ı kapatma fonksiyonu
  // Yeni state'ler ekle
  const showModal = ref(false); // Modal'ın DOM'da olup olmadığını kontrol eder
  const showPopup = ref(false); // Animasyonu kontrol eder

  // Modal'ı kapatma fonksiyonu
  const closeModal = (isFromPopState = false) => {
    showPopup.value = false; // Önce animasyonu başlat
    
    // Eğer kullanıcı manuel kapattıysa (çarpı veya dışarı tıklama) ve geçmişte bizim modal durumu varsa history'den de geri geliyoruz
    if (isFromPopState !== true && window.history.state?.isModalOpen) {
      window.history.back();
    }
  };

  // Animasyon bittiğinde çalışacak fonksiyon
  const handleModalAnimation = (event) => {
    if (event.animationName === 'slideOutRight' && !showPopup.value) {
      showModal.value = false; // Animasyon bittiğinde modal'ı DOM'dan kaldır
    }
  };

  const handlePopState = () => {
    if (showModal.value) {
      // Tarayıcının geri tuşuna basıldı ve modal hala açık. Sayfayı terk etmek yerine sadece modalı kapat.
      closeModal(true);
    }
  };

  const showPetDetails = async (petId) => {
    petStore.fetchPetDetails(petId);
    
    // Vue Router'ın state'ini kopyalayıp sahte bir history state ekliyoruz.
    // Böylece Vue Router'ın kafası karışmaz ve scroll pozisyonu kaybolmaz.
    if (!window.history.state?.isModalOpen) {
      window.history.pushState({ ...window.history.state, isModalOpen: true }, '');
    }
    
    showModal.value = true; // Modal'ı DOM'a ekle
    // nextTick kullanarak DOM güncellemesini bekle
    await nextTick();
    showPopup.value = true; // Animasyonu başlat
  };

  // Lifecycle hooks
  onMounted(async () => {
    window.addEventListener('popstate', handlePopState);
    await fetchCategories();

    // URL'den gelen kategori 'All' ise, null olarak ayarla
    const urlCategory = route.query.category === 'All' ? null : route.query.category;

    filters.value = {
      ...filters.value,
      category: urlCategory || null,
      subCategory: route.query.subCategory || null,
      coatPattern: route.query.coatPattern || null,
      color: route.query.color || null,
      ageGroup: route.query.ageGroup || null,
      priceRangeMinPrice: route.query.priceRangeMinPrice || null,
      priceRangeMaxPrice: route.query.priceRangeMaxPrice || null,
      adType: route.query.adType || null,
      sort: route.query.sort || 'newest',
    };

    if ((filters.value.priceRangeMinPrice || filters.value.priceRangeMaxPrice) && 
        ['newest', 'oldest', 'bestMatch'].includes(filters.value.sort)) {
      filters.value.sort = 'pricelowToHigh';
    }

    await fetchPetAds(false, filters.value);
    setupObserver();
  });

  // Filtreleri URL'e yansıt
  const router = useRouter();
  watch(
    filters,
    (newFilters) => {
      router.push({
        query: {
          ...route.query,
          // Eğer kategori null ise, URL'de hiç gösterme, diğer parametreler de aynı mantıkta
          category: newFilters.category || undefined,
          subCategory: newFilters.subCategory || undefined,
          priceRangeMinPrice: newFilters.priceRangeMinPrice || undefined,
          priceRangeMaxPrice: newFilters.priceRangeMaxPrice || undefined,
          adType: newFilters.adType || undefined,
          sort: newFilters.sort || undefined,
        },
      });
    },
    { deep: true },
  );
  const scrollPosition = ref(0);

  // Watch fonksiyonunu düzenleyelim
  watch(showModal, (isOpen) => {
    if (isOpen) {
      // Mevcut scroll pozisyonunu kaydet
      scrollPosition.value = window.scrollY;

      // Body'yi sabitle

      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      // Body stillerini temizle

      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';

      // Sayfayı eski scroll pozisyonuna getir
    }
  });

  // Lifecycle hooks içinde event listener'ları ekleyin
  onMounted(() => {
    // Touch event'ları için passive true
    const modalFiltre = document.getElementById('modal-filtre');
    if (modalFiltre) {
      modalFiltre.addEventListener('touchstart', handleTouchStart, { passive: true });
      modalFiltre.addEventListener('touchmove', handleTouchMove, { passive: false });
      modalFiltre.addEventListener('touchend', handleTouchEnd, { passive: true });
    }
  });

  // Cleanup
  onUnmounted(() => {
    window.removeEventListener('popstate', handlePopState);
    const modalFiltre = document.getElementById('modal-filtre');
    if (modalFiltre) {
      modalFiltre.removeEventListener('touchstart', handleTouchStart);
      modalFiltre.removeEventListener('touchmove', handleTouchMove);
      modalFiltre.removeEventListener('touchend', handleTouchEnd);
    }
  });
</script>

<style scoped>
.section-separator{
  margin: 5px 0;
}
  .modal-filtre {
    position: fixed;
    top: 0;
    height: 100vh;
    background: white;
    z-index: 1000;
    overflow-y: auto;
    transition: right 0.3s ease;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    padding: 20px;
    width: 300px;
    touch-action: pan-x;
    -webkit-overflow-scrolling: touch;
  }
  .card-text {
    line-height: 20px;
    height: 84px;
    overflow: hidden;
  }
  @media (min-width: 992px) {
    .listingpush {
      min-height: 75px;
    }
  }

  @media (min-width: 1200px) {
    .listingpush {
      min-height: 150px;
    }
  }

  .sort-controls {
    margin: 20px 0;
    text-align: right;
  }

  .sort-controls select {
    padding: 5px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    font-size: 14px;
  }

  #modal-filtre {
    position: fixed;
    top: 0;
    height: 100vh;
    background: white;
    z-index: 1000;
    overflow-y: auto;
    transition: right 0.3s ease;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    padding: 20px;
    width: 300px;
    touch-action: pan-y;
    /* Sadece dikey touch hareketlerine izin ver */
    -webkit-overflow-scrolling: touch;
    /* iOS için smooth scroll */
  }

  #modal-filtre.show-filter {
    left: 0;
    /* Gösterirken sağdan 0 pozisyonuna gelsin */
  }

  .left_sidebar_area {
    height: 100%;
    padding-bottom: 60px;
  }

  /* Mobil için responsive ayarlar */
  @media (max-width: 768px) {
    #modal-filtre {
      width: 100%;
      user-select: none;
      /* Text seçimini engelle */
      -webkit-user-select: none;
      padding: 5px;
    }
  }

  /* Ana içerik için margin ayarı */
  #petListingDiv {
    transition: margin-left 0.3s ease;
  }


  /* Scroll bar stilleri */
  #modal-filtre::-webkit-scrollbar {
    width: 6px;
  }

  #modal-filtre::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  #modal-filtre::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  #modal-filtre::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .hide-animation {
    display: none !important;
  }

  #modal-filtre {
    /* ... mevcut stiller ... */
    animation-duration: 0.8s;
    /* Animasyon süresini ayarlayın */
  }

  .selected-filters {
    padding: 10px 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
  }

  .filter-label {
    font-weight: 500;
    color: #666;
  }

  .filter-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
  }

  .filter-pill {
    display: inline-flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 0.9rem;
    color: #333;
  }

  .remove-filter {
    background: none;
    border: none;
    color: #c5322d;
    margin-left: 5px;
    cursor: pointer;
    padding: 0 5px;
    font-size: 0.8rem;
  }

  .remove-filter:hover {
    color: #a52925;
  }

  .reset-all-filters {
    background-color: #c5322d;
    color: white;
    border: none;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .reset-all-filters:hover {
    background-color: #a52925;
  }

  /* Modal stilleri */
  .pet-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    overflow: hidden;
    /* Arka planın kaymasını engelle */

    touch-action: pan-y;
    /* Sadece dikey touch hareketlerine izin ver */
    animation-duration: 0.5s !important;
    /* Animasyon süresini ayarla */
    -webkit-overflow-scrolling: touch;
    /* iOS için smooth scroll */
  }

  .pet-modal-content {
    background: white;
    border-radius: 0;
    padding: 0;

    max-width: 100%;
    max-height: 100vh;
    /* Modal çok büyükse sınırlama */
    overflow: auto;
    /* Modal içinde kaydırma olsun */
  }

  @media (max-width: 992px) {
  }

  .animate__animated {
    --animate-duration: 0.5s;
  }

  .close-button {
    position: fixed;
    top: 0;
    left: calc(50% - 55px);
    border: rgb(255, 255, 255);
    border-style: solid;
    font-size: 20px;
    cursor: pointer;
    z-index: 11001;
    animation-duration: 1s;
    animation-delay: 500ms;
    display: inline-block;
    border: 1px solid #ddd;
    width: 110px;
    line-height: 28px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    background: #fff;
    color: #592065;
  }

#modal-filtre .left_sidebar_area,
#modal-filtre .left_widgets,
#modal-filtre .p_filter_widgets,
#modal-filtre .widgets_inner,
#modal-filtre .l_w_title,
#modal-filtre .list,
#modal-filtre .mb-3,
#modal-filtre .border {
  background-color: transparent !important;
}

@media (min-width: 992px) {
  .conlist .col-lg-9 {
    flex: 0 0 80% !important;
    width: 80% !important;
    max-width: 80% !important;
  }
}

@media (min-width: 1400px) {
  .conlist .col-lg-9 {
    flex: 0 0 79% !important;
    width: 79% !important;
    max-width: 79% !important;
    padding: 0 !important;
  }
}
</style>
